import React from "react";
import { SvgIcon } from "@mui/material";

function LogoutIcon(props) {
  return (
    <SvgIcon viewBox="0 0 24 24">
      <svg
        id="svg"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0, 0, 400,397.3856209150327"
      >
        <g id="svgg">
          <path
            id="path0"
            d="M75.563 41.013 C 72.188 41.939,68.365 43.500,67.066 44.482 C 60.878 49.166,55.726 54.718,53.153 59.477 L 50.327 64.706 50.327 199.346 L 50.327 333.987
            53.173 339.305 C 56.576 345.662,65.136 353.676,71.713 356.663 C 80.185 360.511,198.684 359.877,206.035 355.945 C 214.498 351.417,219.135 346.884,222.774
            339.582 L 226.144 332.820 226.144 293.207 L 226.144 253.595 209.150 253.595 L 192.157 253.595 192.157 288.889 L 192.157 324.183 137.908 324.183 L 83.660
            324.183 83.660 199.346 L 83.660 74.510 137.908 74.510 L 192.157 74.510 192.157 109.804 L 192.157 145.098 209.150 145.098 L 226.144 145.098 226.115 105.556 C 226.080
            57.090,224.188 51.359,205.346 42.644 C 197.848 39.176,87.322 37.787,75.563 41.013 M268.289 123.213 L 256.219 135.333 278.436 157.521 C 290.656 169.725,300.654
            180.157,300.654 180.705 C 300.654 181.252,262.124 181.699,215.033 181.699 L 129.412 181.699 129.412 199.346 L 129.412 216.993 215.999 216.993 L 302.587
            216.993 279.392 240.216 L 256.197 263.438 268.310 275.501 L 280.424 287.564 324.526 243.448 L 368.628 199.332 324.493 155.212 L 280.359 111.092 268.289 123.213 "
            stroke="none"
          />
        </g>
      </svg>
    </SvgIcon>
  );
}

export default LogoutIcon;
